export default {"src":"/_next/static/media/peaches.f7ece364.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};